import type { ScreenModule } from "../../../app/screen-module";
import { TenantsPage } from "../pages";

export default {
	id: "system-admin.tenants",
	path: "/system/tenants",
	area: "system-admin",
	navGroup: "製品",
	label: "テナント",
	roles: ["platform_admin", "platform_viewer"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: TenantsPage,
} satisfies ScreenModule;
